import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../../../actions/layoutActions";
import { EditProjectType } from "./EditProjectType";
import {
  performUpdateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { useUpdateProcessRequests } from "../../../../../hooks/useProcessRequest";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { convertServerErrorToFormikErrors } from "../../../../../../utils/formValidationUtils";
import propTypes from "../../../../../../constants/propTypes";
import { projectTypeDataComponentId } from "../ProjectTypeContainer";

const EditProjectTypeContainer = ({
  projectType,
  dataComponent,
  performUpdateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
}) => {
  useUpdateProcessRequests(dataComponent, {
    onSuccess: () => {
      showSnackNotificationAction("Project Type saved successfully.");
      setReload(projectTypeDataComponentId, true);
      closeModalDialog();
    },
    onError: error => {
      const convertedError = convertServerErrorToFormikErrors(error);
      showSnackNotificationAction(convertedError.name);
    },
  });

  const handleEditProjectType = values => {
    performUpdateRequest(projectTypeDataComponentId, projectType.id, values);
  };

  return (
    <EditProjectType
      projectType={projectType}
      handleEditProjectType={handleEditProjectType}
      closeModalDialog={closeModalDialog}
    />
  );
};

EditProjectTypeContainer.propTypes = {
  projectType: propTypes.projectType.isRequired,
  dataComponent: propTypes.dataComponent,
  performUpdateRequest: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    dataComponent: getDataComponent(projectTypeDataComponentId, state),
  };
};

const mapDispatchToProps = {
  performUpdateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProjectTypeContainer);
